const categories = [
  {
    name: 'Alger',
    id: 1,
    url: 'alger',
    text:
      "Algerna utgör havets skogar och ängar. Det finns både stora fastsittande alger och mindre frilevande, så kallade <a href='https://www.havet.nu/livet/arter/plankton/vaxtplankton'>växtplankton</a>. De skiljer sig från <a href='https://www.havet.nu/livet/arter/vaxter'>kärlväxterna</a> på flera sätt. De stora fastsittande algerna kräver ett hårt underlag som de kan fästa vid med hjälp av en fästplatta. De har inga rötter utan tar upp näring över hela sin yta."
  },
  {
    name: 'Växter',
    id: 15,
    url: 'vaxter',
    text:
      "I havet finns både <a href='https://www.havet.nu/livet/arter/alger'>alger</a> och kärlväxter. Havets kärlväxter är nära släkt med blomväxterna på land. De har blommor och nästan alla har rötter att rota sig med i mjuka bottnar. Genom rötterna tar de upp näring som transporteras vidare till växtens olika delar. De flesta har sötvattenursprung. Här kan du lära dig mer om kärlväxter, bladmossor och saltlaven."
  },
  {
    name: 'Blötdjur',
    id: 5,
    url: 'blotdjur',
    text:
      'Till blötdjuren, Mollusca, hör snäckor, musslor och bläckfiskar och några grupper till. Det är en mycket artrik stam. De kännetecknas av en mjuk kropp som ofta har ett kalkskal på ut- eller insidan, en fot att röra sig med och ofta en raspig tunga att äta med. Hos vissa grupper kan man inte urskilja alla dessa kännetecken.'
  },
  {
    name: 'Däggdjur',
    id: 3,
    url: 'daggdjur',
    text:
      "Däggdjuren är den grupp som vi människor hör till. Det är en grupp inom stammen ryggsträngsdjur (Chordata) dit även <a href='https://www.havet.nu/livet/arter/fiskar'>fiskar</a> och faktiskt <a href='https://www.havet.nu/livet/arter/sjopungar'>sjöpungar</a> hör. Däggdjuren har ryggrad, reglerad kroppstemperatur och päls och är i huvudsak landlevande. Även de arter som lever hela sina liv i vatten måste andas luft, och många föder sina ungar på land."
  },
  {
    name: 'Fiskar',
    id: 2,
    url: 'fiskar',
    text:
      'Fiskar är en grupp vattenlevande ryggradsdjur med fenor. De flesta arter andas med gälar och är växelvarma. Fiskar är antingen söt- eller saltvattenarter. De kan klara sig i olika salthalter men det är kinkigare för deras rom och yngel. På grund av den låga salthalten i Östersjön finns där en blandning av arter från både salt och sött vatten. I Västerhavet hittar vi endast saltvattenarter.'
  },
  {
    name: 'Insekter',
    id: 9,
    url: 'insekter',
    text:
      "Insekterna hör till samma stam som kräftdjuren. Det är den allra största djurgruppen med mängder av arter och individer som främst lever på landbacken och i luften. De trivs inte i havet. Dock finns en hel del arter som spenderar hela eller delar av sitt liv i utsötade vatten längs kusten och i Bottenviken. Många insektslarver som lever i vatten kan påminna om <a href='https://www.havet.nu/livet/arter/kraftdjur'>kräftdjur</a> eller <a href='https://www.havet.nu/livet/arter/maskar'>maskar</a>. "
  },
  {
    name: 'Kräftdjur',
    id: 4,
    url: 'kraftdjur',
    text:
      "Kräftdjuren hör liksom <a href='https://www.havet.nu/livet/arter/insekter'>insekterna</a> till stammen leddjur, Arthropoda. De har ett yttre skelett, ett skal, som måste bytas ut när djuren växer. Kräftdjuren är en stor grupp, med över tusen arter i svenska vatten. De flesta finns i havet, och många är mycket små och hör därför till <a href='https://www.havet.nu/livet/arter/plankton'>djurplankton</a>. Här hittar man <a href='https://www.havet.nu/livet/art/strandloppa'>tångloppor</a>, <a href='https://www.havet.nu/livet/art/skorv'>skorv</a>, <a href='https://www.havet.nu/livet/art/pungraka'>pungräkor</a> och, kanske lite överraskande, <a href='https://www.havet.nu/livet/arter/kraftdjur/rankfotingar'>havstulpaner</a>. De <a href='https://www.havet.nu/livet/arter/kraftdjur/tiofotade-kraftdjur'>tiofotade</a> kräftdjuren är mycket goda."
  },
  {
    name: 'Maskar',
    id: 6,
    url: 'maskar',
    text:
      'Att vara mask är en livsstil. Det finns mängder av sinsemellan mycket olika djurstammar som anammat denna långsträckta praktiska form. Begreppet maskar är helt enkelt ett gammalt samlingsnamn för olika krälande långsträckta djur. En av de mer välkända är kanske sandmasken, som lämnar sina högar av renad sand på grunda bottnar på västkusten. '
  },
  {
    name: 'Nässeldjur',
    id: 13,
    url: 'nasseldjur',
    text:
      'Nässeldjuren kan se ganska olika ut. En del sitter fast på botten (polyper) och andra är frisimmande (medusor). Några arter växlar mellan dessa former under sitt liv. Alla har dock nässelceller som vid beröring avfyrar en hullingförsedd tråd förbunden med en giftblåsa, ett utmärkt sätt att både fånga föda och försvara sig. Oftast är nässelcellerna för klena för att vi ska känna något, men inte alltid.'
  },
  {
    name: 'Plankton',
    id: 8,
    url: 'plankton',
    text:
      'Att vara plankton är ett levnadssätt. Det är ett samlingsnamn på växter och djur som huvudsakligen driver med havets strömmar. Det finns två huvudtyper av plankton: tusentals arter av pyttesmå växter och mängder av djur som antingen är ganska små eller som simmar dåligt. En del djur är plankton i hela sitt liv, men många är det bara i sin ungdom. '
  },
  {
    name: 'Sjöpungar',
    id: 14,
    url: 'sjopungar',
    text:
      'Sjöpungar är ganska genomskinliga säckliknande djur. De är fastsittande filtrerare som ofta är jättemånga, och en del arter bildar kolonier. Det finns ett tjugotal arter som är vanliga vid den svenska västkusten. De är nära släktingar till oss, eftersom de tillhör ryggsträngsdjuren. De frisimmande larverna har en ryggsträng som tillbakabildas när den hittat en boplats. '
  },
  {
    name: 'Tagghudingar',
    id: 12,
    url: 'tagghudingar',
    text:
      'Till tagghudingarna hör sjöstjärnor, sjöborrar, ormstjärnor, hårstjärnor och sjögurkor. De lever oftast på botten och är ganska stora, mer eller mindre taggiga djur som saknar huvud. De rör sig långsamt med hjälp av hundratals slangfötter och har munnen vänd nedåt. Det är en artrik grupp som bara finns i havet. Ett 80-tal arter finns vid svenska västkusten, inga i Östersjön.'
  },
  {
    name: 'Udda grupper',
    id: 7,
    url: 'udda-grupper',
    text:
      'Här har vi samlat ihop arter och grupper som är vanliga att hitta, men som ändå är för få eller för okända för att göra en huvudgrupp av. I havet finns en fantastisk mångfald av djurgrupper. Många fler än på land.'
  }
]

export { categories }
